module.exports = __webpack_public_path__ + "img/content6-10.6b6133db.webp";